<template>
  <div class="mypage-user-complete-pane">
    <mypage-user-complete-section />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypageUserCompleteSection from '@/components/MypageUserCompletePage/MypageUserCompletePane/MypageUserCompleteSection.vue'

/**
 * マイページ: 会員情報変更完了 コンテンツペイン
 */
export default defineComponent({
  name: 'MypageUserCompletePane',
  components: {
    MypageUserCompleteSection,
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.mypage-user-complete-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  padding-bottom: 80px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
